import {gql} from '@apollo/client';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary from 'chemistry/ChemicalCounterpartLibrary';
import {createSalt} from 'chemistry/ChemistryDAO';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {ErrorFragment} from 'graphql-client/Error';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

import {SaltLibraryQuery} from './__generated/SaltLibraryQuery';

export const SALT_LIBRARY_QUERY = gql`
  query SaltLibraryQuery @skipAudit @engComponent(name: CHEMISTRY) {
    salts {
      id
      name
      code
      calculatedMolecularWeight
      canonicalSmiles
      imageData {
        ... on SVGNode {
          base64Svg
        }
        ...Error
      }
    }
  }
  ${ErrorFragment.fragment}
`;

export default function SaltLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Salts');
  }, []);

  const result = useBenchlingQuery<SaltLibraryQuery>(SALT_LIBRARY_QUERY);

  return (
    <ChemicalCounterpartLibrary
      itemName="salt"
      items={result.type === QueryResultType.SUCCESS ? result.data.salts : []}
      loading={result.type === QueryResultType.PENDING}
      tableKey={TABLE_KEYS.SALT_LIBRARY_TABLE}
      onAddNew={async (name: string, code: string, sketcherValue: string) => {
        await createSalt(name, sketcherValue, code || undefined);
        // Refetch GQL query to include new salt in the results.
        await result.refetch();
      }}
    />
  );
}
